export const checkForInvalidFileExtension = (fileList: FileList, acceptedFileTypes: string): boolean => {
    for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
        const file = fileList[i];
        const allowedTypes = acceptedFileTypes.split(",");
        // eslint-disable-next-line @stencil-community/strict-boolean-conditions
        const isValid = !!allowedTypes.find((allowedType: string) => {
            if (allowedType.endsWith("*")) {
                const allowedTypes = allowedType.substring(0, allowedType.length - 1);
                return file.type.startsWith(allowedTypes);
            } else {
                return allowedType === file.type;
            }
        });
        if (!isValid) {
            return false;
        }
    }
    return true;
};

export const checkForInvalidFileSize = (fileList: FileList, allowedSize: number): boolean => {
    for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
        const file = fileList[i];
        if (file.size > allowedSize) {
            return false;
        }
    }
    return true;
};

export const checkForTooManyFiles = (fileList: FileList, maxFiles: number, currentFilesNumber: number): boolean => {
    if (fileList.length > maxFiles || currentFilesNumber + fileList.length > maxFiles) {
        return false;
    } else {
        return true;
    }
};
